import { SettingsTextField } from '@/components/settings/SettingsTextField.tsx';
import SettingsToggle from '@/components/settings/SettingsToggle.tsx';
import { DashboardContext } from '@/contexts/DashboardContext.tsx';
import Button from '@superfunnel/ui-core/v2/Button';
import { useContext, useEffect, useState } from 'react';
import { useDynamicPageSettingsContext } from './DynamicPageSettingsContext';

export const Tracking = () => {
  const [edit, setEdit] = useState<boolean>(false);
  const { domains } = useContext(DashboardContext);
  const { dynamicPage, updatePage } = useDynamicPageSettingsContext();

  const [urlSuffix, setUrlSuffix] = useState<string>('');
  const [disableAutoAddParameters, setDisableAutoAddParameters] =
    useState<boolean>(true);

  useEffect(() => {
    if (!dynamicPage) return;

    setUrlSuffix(dynamicPage?.config?.urlSuffix || '');
    setDisableAutoAddParameters(
      dynamicPage?.config?.disableAutoAddParameters === true,
    );
  }, [domains, dynamicPage]);

  const onSave = () => {
    if (!dynamicPage) return;
    setEdit(false);
    updatePage({
      config: {
        ...dynamicPage.config,
        urlSuffix,
        disableAutoAddParameters,
      },
    });
  };
  const onDiscard = () => {
    setEdit(false);
    setUrlSuffix(dynamicPage?.config?.urlSuffix || '');
    setDisableAutoAddParameters(
      dynamicPage?.config?.disableAutoAddParameters === true,
    );
  };

  useEffect(() => {
    setEdit(
      (dynamicPage?.config?.urlSuffix ?? '') !== urlSuffix ||
        (dynamicPage?.config?.disableAutoAddParameters === true) !==
          disableAutoAddParameters,
    );
  }, [dynamicPage, urlSuffix, disableAutoAddParameters]);

  return (
    <div className={'flex h-full w-full flex-col gap-4 overflow-hidden'}>
      <div className={'h-full w-full overflow-y-auto pb-6'}>
        <div className="border-base-200 grid gap-4 md:ml-46 md:border-l md:pl-6">
          <SettingsTextField
            title="URL Suffix"
            value={urlSuffix}
            setValue={setUrlSuffix}
            helpText="Add a fixed suffix to all links on your pages"
            placeholder="param1=value1&param2=value2"
            pattern="^([a-zA-Z0-9_]+=(?:[a-zA-Z0-9_\-]+|\{\{[a-zA-Z0-9_]+\}\}))(?:&[a-zA-Z0-9_]+=(?:[a-zA-Z0-9_\-]+|\{\{[a-zA-Z0-9_]+\}\}))*$"
          />
          <SettingsToggle
            title="Add Parameters Automatically"
            value={!disableAutoAddParameters}
            setValue={(v) => setDisableAutoAddParameters(!v)}
            helpText="If enabled, all url parameters will be added automatically to the links on your pages. If disabled, you will need to add them manually."
          />
        </div>
      </div>
      {edit && (
        <div
          className={
            'border-base-200 col-span-2 flex justify-end gap-3 border-t pt-4'
          }
        >
          <Button variant={'outline'} onClick={onDiscard}>
            Discard
          </Button>
          <Button type={'button'} onClick={onSave}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};
